if (!customElements.get('firework-embed-header')) {
  class FireworkEmbedHeader extends HTMLElement {
    constructor() {
      super();
      this._carouselSwiper = null;
    }

    connectedCallback() {
      this.initCarousel();
    }

    disconnectedCallback() {
      this.destroyCarousel();
    }

    destroyCarousel() {
      if (this._carouselSwiper && !this._carouselSwiper.destroyed) {
        this._carouselSwiper.destroy(true, true);
      }
      this._carouselSwiper = null;
    }

    initCarousel() {
      const carouselEl = this.querySelector('[data-firework-carousel]');
      if (!carouselEl || typeof Swiper === 'undefined') return;

      this.destroyCarousel();

      const slideCount = carouselEl.querySelectorAll('.swiper-slide').length;
      if (slideCount < 1) return;

      const canLoop = slideCount > 1;
      const scrollSpeed = Number(this.dataset.autoplaySpeed) || 8000;
      const carouselWrap = this.querySelector('.firework-embed-header__carousel-wrap');

      this._carouselSwiper = new Swiper(carouselEl, {
        loop: canLoop,
        loopAdditionalSlides: slideCount,
        slidesPerView: 'auto',
        spaceBetween: 16,
        speed: scrollSpeed,
        allowTouchMove: true,
        grabCursor: true,
        watchOverflow: true,
        resistanceRatio: 0.85,
        autoplay: canLoop
          ? {
              delay: 0,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }
          : false,
        breakpoints: {
          750: {
            spaceBetween: 20,
          },
          990: {
            spaceBetween: 24,
          },
        },
      });

      if (carouselWrap && this._carouselSwiper.autoplay) {
        carouselWrap.addEventListener('mouseenter', () => {
          if (this._carouselSwiper?.autoplay) this._carouselSwiper.autoplay.stop();
        });
        carouselWrap.addEventListener('mouseleave', () => {
          if (this._carouselSwiper?.autoplay) this._carouselSwiper.autoplay.start();
        });
      }
    }
  }

  customElements.define('firework-embed-header', FireworkEmbedHeader);
}

document.addEventListener('shopify:section:load', (event) => {
  const section = event.target.querySelector('firework-embed-header');
  if (section && typeof section.initCarousel === 'function') {
    section.initCarousel();
  }
});

document.addEventListener('shopify:section:unload', (event) => {
  const section = event.target.querySelector('firework-embed-header');
  if (section && typeof section.destroyCarousel === 'function') {
    section.destroyCarousel();
  }
});
